import { render, staticRenderFns } from "./OrderDetailTabs.vue?vue&type=template&id=40939e82&scoped=true"
import script from "./OrderDetailTabs.vue?vue&type=script&lang=js"
export * from "./OrderDetailTabs.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailTabs.vue?vue&type=style&index=0&id=40939e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40939e82",
  null
  
)

export default component.exports